module.exports = "/images/cr.svg?b1386529226ca6d4d73a06dc35d5eb8f";